import { ValidatorFn, AbstractControl } from '@angular/forms';


export function requiredWithTrimValueValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value: string = (control.value || '').trim();

        if (value?.length === 0) {
            return { 'required': true };
        }

        return null;
    };
}
